import React, { useEffect } from "react"
import moment from "moment"
import { StyleSheet, View } from "react-native"
import { useCountDown } from "../../common/hooks/useCountDown"
import TextM from "../../common/components/text/TextM"
import { formatDaysHoursMinutesSeconds } from "../../data/utility/Utils"
import { theme } from "../../common/theme/theme"

const getTimerLabel = (key) => {
    switch (key) {
        case "days":
            return "Jours"
        case "hours":
            return "Heures"
        case "minutes":
            return "Minutes"
        case "seconds":
            return "Secondes"
    }
}

export const DiscountCard = ({ discountDeadline, discountAmount }) => {
    const { countdown, initializeCountdown } = useCountDown({
        durationInSec: moment(discountDeadline).diff(moment(), "seconds"),
    })

    useEffect(() => {
        if (!discountDeadline) return
        initializeCountdown()
    }, [discountDeadline])

    const TimerCard = ({ label, value }) => {
        return (
            <View style={{ alignItems: "center" }}>
                <View style={styles.timer}>
                    <TextM fontWeight="Bold" color={theme.colors.white}>
                        {value < 10 ? `0${value}` : value}
                    </TextM>
                </View>
                <TextM
                    fontSize={12}
                    color={theme.colors.error}
                    fontWeight="Medium"
                >
                    {getTimerLabel(label)}
                </TextM>
            </View>
        )
    }

    const discountMessage = discountAmount
        ? `🎁 Offre limitée - Remise immédiate de ${discountAmount}€`
        : `🎁 Offre limitée - Remise immédiate sur votre 1er mois`

    return countdown > 0 ? (
        <View style={styles.card}>
            <TextM
                wrap
                fontWeight="Bold"
                color={theme.colors.error}
                fontSize={16}
                style={{ textAlign: "center" }}
            >
                {discountMessage}
            </TextM>
            <TextM
                wrap
                fontWeight="Medium"
                color={theme.colors.error}
                fontSize={12}
            >
                ⏰ Se termine dans :
            </TextM>
            <View style={styles.row}>
                {Object.entries(formatDaysHoursMinutesSeconds(countdown)).map(
                    ([key, value]) =>
                        ((key === "days" && value > 0) || key !== "days") && (
                            <TimerCard key={key} label={key} value={value} />
                        )
                )}
            </View>
        </View>
    ) : null
}

const styles = StyleSheet.create({
    card: {
        backgroundColor: theme.colors.errorLight,
        borderRadius: 12,
        padding: 24,
        borderWidth: 2,
        borderColor: theme.colors.error,
        gap: 16,
        alignItems: "center",
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        gap: 16,
    },
    timer: {
        backgroundColor: theme.colors.error,
        width: 60,
        height: 50,
        borderRadius: 12,
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 4,
    },
})
